import React from 'react';

const IconLoader = () => (
  <svg id="logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width="100"
    height="100"
    aria-hidden="true"
  >
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(40.000, 29.000) scale(0.75)" /*transform="translate(11.000000, 5.000000)"*/>
        <path
          d="M0 45.26L0 9.47L15.87 9.47Q20.65 9.47 23.14 10.44Q25.63 11.40 27.12 13.84Q28.61 16.28 28.61 19.24Q28.61 23.05 26.15 25.66Q23.68 28.27 18.53 28.98Q20.41 29.88 21.39 30.76Q23.46 32.67 25.32 35.52L31.54 45.26L25.59 45.26L20.85 37.82Q18.77 34.59 17.43 32.89Q16.09 31.18 15.03 30.49Q13.96 29.81 12.87 29.54Q12.06 29.37 10.23 29.37L4.74 29.37L4.74 45.26L0 45.26M4.74 25.27L14.92 25.27Q18.16 25.27 20.00 24.60Q21.83 23.93 22.78 22.45Q23.73 20.97 23.73 19.24Q23.73 16.70 21.89 15.06Q20.04 13.43 16.06 13.43L4.74 13.43L4.74 25.27Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.2"
        />
      </g>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
          L 11, 27
          L 11, 72
          L 50, 95
          L 89, 73
          L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
